import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Link 
            to="/" 
            className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeftIcon className="w-4 h-4 mr-2" />
            Back to Home
          </Link>
          <div className="flex items-center gap-3">
            <ShieldCheckIcon className="w-8 h-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
          </div>
          <p className="text-gray-600 mt-2">Last updated: {new Date().toLocaleDateString()}</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm p-8 prose prose-lg max-w-none">
          
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">What We Collect</h2>
            <ul className="space-y-2 text-gray-700">
              <li>• Email addresses (when you create games or join leaderboards)</li>
              <li>• Game data and scores</li>
              <li>• Usage analytics (how you use our platform)</li>
              <li>• Device information (browser type, IP address)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">How We Use Your Information</h2>
            <ul className="space-y-2 text-gray-700">
              <li>• To provide and improve our gaming services</li>
              <li>• To save your game progress and scores</li>
              <li>• To send important service updates</li>
              <li>• To analyze usage patterns and improve the platform</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Third-Party Services</h2>
            <p className="text-gray-700 mb-4">We use the following trusted services:</p>
            <ul className="space-y-2 text-gray-700">
              <li>• <strong>Firebase (Google)</strong> - For data storage and authentication</li>
              <li>• <strong>Google Analytics</strong> - For usage analytics</li>
              <li>• <strong>reCAPTCHA</strong> - For spam protection</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Your Rights</h2>
            <ul className="space-y-2 text-gray-700">
              <li>• Access your personal data</li>
              <li>• Request data deletion</li>
              <li>• Opt out of analytics</li>
              <li>• Contact us with privacy concerns</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Data Security</h2>
            <p className="text-gray-700">
              We use industry-standard security measures to protect your data. All data is encrypted 
              in transit and at rest using Firebase's secure infrastructure.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Children's Privacy</h2>
            <p className="text-gray-700">
              Our service is not intended for children under 13. We do not knowingly collect 
              personal information from children under 13.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Contact Us</h2>
            <p className="text-gray-700">
              Questions about this privacy policy? Contact us at{' '}
                              <a href="mailto:support@groupchatheroes.com" className="text-blue-600 hover:underline">
                  support@groupchatheroes.com
                </a>
            </p>
          </section>

          <div className="border-t pt-6 mt-8">
            <p className="text-sm text-gray-500">
              This privacy policy may be updated from time to time. We'll notify users of any 
              significant changes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 